export const guaranteeTypes = [
  'Bid Bond',
  'Performance Guarantee',
  'Advance Payment Guarantee',
  'Retention Money Guarantee',
  'Customs/Import Duty Guarantee',
  'Financial Guarantee',
  'Maintenance Guarantee',
  'Rental Guarantee',
  'Shipping Guarantee',
  'Tax Guarantee'
 ];

 export const tenures =[
  '3 Months',
  '6 Months',
  '12 Months',
  '18 Months',
  '24 Months',
  '36 Months',
  '60 Months'
 ]